import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) {}

  getTestate(data){
    const promise = new Promise<any>((resolve, rejects) =>{
      this.http.post<any>(environment.apiUrl+ "testate", data).toPromise().then(response => {
        resolve(response);
      }).catch(error =>{
        rejects(error);
      })
    });
    return promise;
  }

  getEdizioni(data){
     const promise = new Promise<any>((resolve,reject)=>{
      this.http.post<any>(environment.apiUrl+ "edizioni", data).toPromise().then(response =>{
        resolve(response);
      }).catch(error =>{
        reject(error);
      })
    });
    return promise;
  }

  getSezioni(data){
    const promise = new Promise<any>((resolve,reject)=>{
      this.http.post<any>(environment.apiUrl + 'Sezioni', data).toPromise().then(response =>{
        resolve(response);
      }).catch(error =>{
        reject(error);
      })
    });
    return promise;
  }

  getListaPagine(id_pubblicazione){
    const promise = new Promise<any>((resolve,reject)=>{
      this.http.post<any>(environment.apiUrl + 'Sezioni', id_pubblicazione).toPromise().then(response =>{
        resolve(response);
      }).catch(error =>{
        reject(error);
      })
    });
    return promise;

  }

  getArticoliAllInfo(data){
    const promise = new Promise<any>((resolve,reject)=>{
        this.http.post<any>(environment.apiUrl + "articoli", data).toPromise().then(response =>{
        resolve(response);
      }).catch(error =>{
        reject(error);
      })
    });
    return promise;
  }

  getArticoli(data){
    const promise = new Promise<any>((resolve,reject)=>{
      this.http.post<any>(environment.apiUrl + 'articoli', data).toPromise().then(response =>{
        resolve(response);
      }).catch(error =>{
        reject(error);
      })
    });
    return promise;
  }

  getArticolo(data){
    const promise = new Promise<any>((resolve,reject)=>{
      this.http.post<any>(environment.apiUrl + 'articolo', data).toPromise().then(response =>{
        resolve(response);
      }).catch(error =>{
        reject(error);
      })
    });
    return promise;
  }

  getArticoloByPage(id_articolo){
    const promise = new Promise<any>((resolve,reject)=>{
      this.http.post<any>(environment.apiUrl, id_articolo).toPromise().then(response =>{
        resolve(response);
      }).catch(error =>{
        reject(error);
      })
    });
    return promise;
  }

  getArticoliByPublicazioneLight(id_pubblicazione){
    const promise = new Promise<any>((resolve,reject)=>{
      this.http.get<any>(environment.apiUrl+ 'LeggiPAG.aspx?id_pubblicazione='+id_pubblicazione).toPromise().then(response =>{
        resolve(response);
      }).catch(error =>{
        reject(error);
      })
    });
    return promise;

  }

  getArticoliByPublicazioneFull(id_pubblicazione){
    const promise = new Promise<any>((resolve,reject)=>{
      this.http.post<any>(environment.apiUrl, id_pubblicazione).toPromise().then(response =>{
        resolve(response);
      }).catch(error =>{
        reject(error);
      })
    });
    return promise;

  }

  searchByTitoloOrTesto(request){
    const promise = new Promise<any>((resolve,reject)=>{
      this.http.post<any>(environment.apiUrl + 'findarticolo', request).toPromise().then(response =>{
        resolve(response);
      }).catch(error =>{
        reject(error);
      })
    });
    return promise;
  }

  refreshToken(body){
    let options = {
      headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
    }; 
    const promise = new Promise<any>((resolve, rejects) =>{
        this.http.post<any>(environment.apiUrl + 'token',body,options).toPromise().then(response =>{
            resolve(response);
        }).catch(error => {
            rejects(error)
        });
    });
    return promise;
  }

  getPubblicazione(request) {
    const promise = new Promise<any>((resolve, rejects)=>{
      this.http.post<any>(environment.apiUrl + 'pubblicazioni', request).toPromise().then(response =>{
        resolve(response);
      }).catch(error =>{
        rejects(error);
      })
    })
    return promise;
  }

  getArticoliByPage(request){
    const promise = new Promise<any>((resolve,rejects)=>{
      this.http.post<any>(environment.apiUrl + 'articolixpagina', request).toPromise().then(response =>{
        resolve(response);
      }).catch(error=>{
        rejects(error);
      })
    })
    return promise;
  }
}
